//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "forget-password",
  data: function data() {
    return {
      userForgetPasswordInfo: {
        username: '',
        idType: '',
        nricFin: '',
        perEmail: ''
      },
      idType: [{ value: null, text: '=ID Type=', disabled: true, selected: true }, { value: 'NRIC', text: 'NRIC' }, { value: 'FIN', text: 'FIN' }]
    };
  },

  methods: {
    userForgetPassword: function userForgetPassword() {
      this.$emit('userForgetPassword', this.userForgetPasswordInfo);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/ForgetPassword.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/ForgetPassword.vue
// module chunks = 7